<template>
    <v-row class="pb-3">
        <v-col cols="4" class="pb-5 pr-0 d-flex align-center">
            <SearchFilter 
                @keydown.enter="filter" 
                :context="context" 
                :alvqa="alvqa + '-textfield-search'"
                :iconTooltipText="$t('lang_CONTRACTS_LABEL_TOOLTIP_PANEL_TRACKS_SEARCH_FIELD')"
            />
            <span class="pt-4">
                <BaseIcon 
                    :alvqa="alvqa + '-icon-search'"
                    @click="filter" 
                    icon="fa-search" 
                    tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
                />
            </span>
        </v-col>
        <v-col 
            cols="3" 
            align-self="center"
            class="pt-6"
        >
            <BaseButton 
                :disabled="!showDeleteResultListButton"
                @click="deleteResultlist"
                label="lang_GENERIC_BUTTON_CAPTION_REMOVE"
                :alvqa="alvqa + '-button-delete-result'"
                block
            />
        </v-col>
        <v-col 
            cols="5"
            align-self="center"
            class="v-label theme--light mt-2 pl-0"
        >
            <BaseHeaderStats 
                context="TrackReleasesForSubCataloguesSearch" 
                typeStats="LIST"
                :alvqa="alvqa"
                :specificSelected="$store.getters.getTotalListed"
            />
        </v-col>
    </v-row>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "LabelContractsTrackReleasesEditPanelTopSlot",
    components: {
        BaseButton,
        BaseIcon,
        SearchFilter,
        BaseHeaderStats
    },
    props: {
        subcatalogue: Object
    },
    data() {
        return {
            alvqa: 'track-releases-edit-form-panel-works',
            context: 'LabelContractsTracksReleases'
        }
    },
    computed: {
        showDeleteResultListButton() { return this.$store.getters.getShowTracksReleasesDeleteResultListButton },
        setTypeOfWorksFor()     { return this.$store.getters.getLabelContractsDetailsType},
        disableSetWorksTypeButton()  {
            if(this.$store.getters.getLabelContractsTracksReleases.length === 0){
                return true
            }else{
                return false
            }
        },
    },
    methods: {
        filter() {
            this.$store.commit('setLabelContractsTracksReleasesCurrentPage', 1)
            this.$store.dispatch('fetchLabelContractsTracksReleases')
        },
        deleteResultlist() {
            this.$store.commit('setDeletionDialogContext', 'AllTracksReleasesFromLabelContract')
            this.$store.commit('setShowDeletionDialog', true)
        }
    }
}
</script>